import { createSlice } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import { ApiStatus } from "../../utils/api.types";
import { fetchStates } from "./stateThunk";
import { IStateSliceState } from "../../utils/state.types";

/**
 * State slice initial state.
 */
const initialState: IStateSliceState = {
    countryStates: [],
    status: ApiStatus.IDLE,
    errorMessage: ''
}

/**
 * State Slice.
 */
const stateSlice = createSlice({
    name: 'state',
    initialState: initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            // Fetch countries
            .addCase(fetchStates.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(fetchStates.fulfilled, (state, action) => {
                state.status = ApiStatus.SUCCESS;
                state.countryStates = action.payload || [];
                state.errorMessage = '';
            })
            .addCase(fetchStates.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message
            })

            
    }
});

export default stateSlice.reducer;
